import { render, staticRenderFns } from "./AccountVerification.vue?vue&type=template&id=37db918a&scoped=true&"
import script from "./AccountVerification.vue?vue&type=script&lang=ts&"
export * from "./AccountVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AccountVerification.vue?vue&type=style&index=0&id=37db918a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db918a",
  null
  
)

export default component.exports